export interface ISubNameSpecifiable {
  subName: string;
}

export function instanceOfISubNameSpecifiable(instance: any): instance is ISubNameSpecifiable {
  return instance
      && (instance.subName !== undefined);
}
